import styled from 'styled-components';

export default styled.div`
  flex: 0 0 100%;
  margin-top: 1rem;
  display: flex;
  justify-content: center;
  align-items: center;
`;
